/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Body } from "sunday-component";
import styled from "styled-components";
import SubMenuDrawer from "./SubMenuDrawer";
import { HeaderMenu } from "../IHeader";

const MainMenuContainer = styled.div`
  @media only screen and (max-width: 1100px) {
    display: none;
  }
`;

const UpDownIcon = styled.span`
  padding-left: 1rem;
  font-size: 14px;
`;

const MainMenuUl = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const MainMenuLi = styled.li`
  margin-right: 40px;
  :last-of-type {
    margin-right: 0px;
  }
`;

const MainMenuText = styled.div`
  color: #2b2b2b;
  :hover {
    color: #ff875e;
    cursor: pointer;
  }
`;

const MainMenuLink = styled.a`
  color: #2b2b2b;
  :hover {
    color: #ff875e;
  }
`;

const MainMenuBody = styled(Body)`
  :hover {
    color: #ff875e;
  }
`;

type CustomMainMenuProps = {
  subMenuVisible: boolean;
  setSubMenuVisible: any;
  menus?: HeaderMenu;
};

const MainMenu = ({
  subMenuVisible,
  setSubMenuVisible,
  menus,
}: CustomMainMenuProps): JSX.Element => {
  const { t, i18n } = useTranslation("layout");

  const triggerSubMenu = () => setSubMenuVisible(!subMenuVisible);
  const closeSubMenu = () => setSubMenuVisible(false);

  return (
    <>
      <MainMenuContainer>
        <MainMenuUl>
          <MainMenuLi>
            <MainMenuText onClick={triggerSubMenu}>
              <MainMenuBody level={5}>
                {t("header.buyOnline")}
                <UpDownIcon>
                  {subMenuVisible ? <UpOutlined /> : <DownOutlined />}
                </UpDownIcon>
              </MainMenuBody>
            </MainMenuText>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={
                menus?.privilege?.href ||
                `https://easysunday.com/${i18n.language}/privilege`
              }
            >
              <MainMenuBody level={5}>
                {menus?.privilege?.label || t("header.privilege")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={
                menus?.faq?.href ||
                `https://easysunday.com/${i18n.language}/faq`
              }
            >
              <MainMenuBody level={5}>
                {menus?.faq?.label || t("header.faq")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={menus?.blog?.href || `https://easysunday.com/blog`}
            >
              <MainMenuBody level={5}>
                {menus?.blog?.label || t("header.blog")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={
                menus?.contactUs?.href ||
                `https://easysunday.com/${i18n.language}/contact-us`
              }
            >
              <MainMenuBody level={5}>
                {menus?.contactUs?.label || t("header.contactus")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={menus?.aboutUs?.href || `https://about.easysunday.com`}
            >
              <MainMenuBody level={5}>
                {menus?.aboutUs?.label || t("header.about")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
        </MainMenuUl>
      </MainMenuContainer>
      <SubMenuDrawer visible={subMenuVisible} onClose={closeSubMenu} />
    </>
  );
};

export default MainMenu;
